import React, { useState } from "react";
import logo from "../../img/logo.png";
import adminIcon from "../../img/admin-panel.png";
import userIcon from "../../img/user.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Auth/AuthContext";
import { Link } from "react-router-dom";

function Navigation() {
  const [showStaffMenu, setShowStaffMenu] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const onLogout = async () => {
    try {
      await logout();
      navigate("/signin");
    } catch (error) {
      console.error("Logout error:", error);
      localStorage.removeItem("authToken");
      navigate("/signin");
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white shadow-lg border-b border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo & Brand */}
          <div className="flex items-center space-x-3">
            <img src={logo} alt="Logo" className="h-8 w-8 object-contain" />
            <span className="text-xl font-bold text-gray-800">HR Management</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            {/* Dashboard */}
            <Link 
              to="/dashboard" 
              className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Dashboard
            </Link>

            {/* Staff Management Dropdown */}
            <div className="relative">
              <button
                className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center space-x-1"
                onClick={() => setShowStaffMenu(!showStaffMenu)}
              >
                <span>Staff Management</span>
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>

              {showStaffMenu && (
                <div className="absolute left-0 mt-2 w-56 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200">
                  <Link 
                    to="/comprehensive-staff-wizard" 
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                    onClick={() => setShowStaffMenu(false)}
                  >
                    Add New Staff
                  </Link>
                  <Link 
                    to="/staff-management" 
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                    onClick={() => setShowStaffMenu(false)}
                  >
                    Edit/Delete Staff
                  </Link>
                </div>
              )}
            </div>

            {/* Export Data */}
            <Link 
              to="/data-export" 
              className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Export Data
            </Link>

            {/* User Profile with Settings */}
            <div className="relative">
              <div
                className="flex items-center space-x-2 cursor-pointer p-2 rounded-lg hover:bg-gray-100 transition-colors"
                onClick={() => setShowUserMenu(!showUserMenu)}
              >
                <div className="w-8 h-8 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                  {user && user.role === "admin" ? (
                    <img src={adminIcon} alt="Admin" className="w-full h-full object-cover" />
                  ) : (
                    <img src={userIcon} alt="User" className="w-full h-full object-cover" />
                  )}
                </div>
                <div className="text-left">
                  <span className="block text-sm font-medium text-gray-900">
                    {user ? user.id : "Guest"}
                  </span>
                  <span className="block text-xs text-gray-600">{user ? user.role : ""}</span>
                </div>
                <svg className="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </div>

              {showUserMenu && (
                <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200">
                  <div className="px-4 py-3 border-b border-gray-100">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                        {user && user.role === "admin" ? (
                          <img src={adminIcon} alt="Admin" className="w-full h-full object-cover" />
                        ) : (
                          <img src={userIcon} alt="User" className="w-full h-full object-cover" />
                        )}
                      </div>
                      <div>
                        <div className="text-sm font-medium text-gray-900">
                          {user ? user.id : "Guest"}
                        </div>
                        <div className="text-sm text-gray-600">
                          {user ? user.role : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Admin Only - User Management */}
                  {user?.role === "admin" && (
                    <Link 
                      to="/user-management" 
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                      onClick={() => setShowUserMenu(false)}
                    >
                      User Management
                    </Link>
                  )}
                  
                  <button 
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors" 
                    onClick={onLogout}
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
              onClick={() => setShowStaffMenu(!showStaffMenu)}
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {showStaffMenu && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t border-gray-200">
            <Link 
              to="/dashboard" 
              className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md text-sm font-medium"
              onClick={() => setShowStaffMenu(false)}
            >
              📊 Dashboard
            </Link>
            <Link 
              to="/comprehensive-staff-wizard" 
              className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md text-sm font-medium"
              onClick={() => setShowStaffMenu(false)}
            >
              ➕ Add New Staff
            </Link>
            <Link 
              to="/staff-management" 
              className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md text-sm font-medium"
              onClick={() => setShowStaffMenu(false)}
            >
              ✏️ Edit/Delete Staff
            </Link>
            <Link 
              to="/data-export" 
              className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md text-sm font-medium"
              onClick={() => setShowStaffMenu(false)}
            >
              📤 Export Data
            </Link>
            {user?.role === "admin" && (
              <>
                <Link 
                  to="/user-management" 
                  className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md text-sm font-medium"
                  onClick={() => setShowStaffMenu(false)}
                >
                  👤 User Management
                </Link>
              </>
            )}
            <button 
              className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md text-sm font-medium"
              onClick={onLogout}
            >
              🚪 Logout
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navigation;
